import { Action } from 'redux-pack'
import { LoadMasks } from '../../connection/masks';

export const LOAD_MASKS = "LOAD_MASKS";
export function loadMasks(room: number): Action {
	return {
		type: LOAD_MASKS,
		promise: LoadMasks(room)
	}
}

